import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../../api/endpoints";
import axiosInstance from "../../../api/axiosInstance";
import { RootState } from "../../../redux/store";

export interface SpecialArticle {
  numeroArticle: string;
  libelleArticle: string;
  uniteArticle: string;
  prixArticle: string;
  qtyArticle: string;
}

interface SaveSpecialArticleState {
  data: SpecialArticle | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: SaveSpecialArticleState = {
  data: null,
  status: "idle",
  error: null,
};

export interface SaveSpecialArticleInput {
  scenario: string;
  siteVente: string;
  siteExpedition: string;
  listQR: {
    questionName: string;
    questionValue: string;
  }[];
  numeroClient: string;
  qty: number;
}

export const saveSpecialArticle = createAsyncThunk(
  "articles/saveSpecialArticle",
  async (data: SaveSpecialArticleInput, {getState , rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        endpoints.articles.saveSpecialArticle,
        data
      );
      //    const state = getState() as RootState;
      //       const token = state.authSlice.token;
      // const response = await axios.post(
      //   "http://localhost:5000/api/Articles/SaveSageArticle",
      //  data,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${token}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data || "Network error");
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

const saveSpecialArticleSlice = createSlice({
  name: "saveSpecialArticle",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveSpecialArticle.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(saveSpecialArticle.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(saveSpecialArticle.rejected, (state) => {
        state.status = "failed";
        state.error = "Erreur lors de la sauvegarde de l'article spécial!";
      });
  },
});

export default saveSpecialArticleSlice.reducer;
